// Assessment question content — referenced by QuestionRenderer.

export const DOMAIN_QUESTIONS = {
  domain1: [
    'Daily work decisions can be made by the relevant staff without always waiting for one specific individual.',
    'Accounting or operational work can continue even when the key person is absent.',
    'Decision-making authority in the workflow is clearly distributed.',
    'Tasks do not depend too heavily on the experience of only one individual.',
    'Important work knowledge is shared and not concentrated in one person.'
  ],
  domain2: [
    'Accounting or operational work is carried out using the same steps each time.',
    'All staff follow standard procedures for the same task.',
    'The way work is done does not vary greatly between individuals.',
    'The sequence of work is clear and predictable.',
    'Tasks can be completed consistently without major variation between staff.'
  ],
  domain3: [
    'The same data does not need to be entered repeatedly in the work process.',
    'The same record corrections do not frequently occur in daily operations.',
    'Report preparation does not involve excessive repetitive manual work.',
    'Information does not need to be repeatedly transferred from one document to another.',
    'The current workflow successfully reduces repetitive routine tasks with little added value.'
  ],
  domain4: [
    'There is systematic checking before reports or records are finalized.',
    'Work verification is performed consistently.',
    'Errors are usually detected before reports are submitted or used.',
    'There are clear controls to reduce operational errors.',
    'Error detection does not depend only on the experience of specific individuals.'
  ]
};

export const EXTENDED_QUESTIONS = {
  e1: [
    'Accounting or operational data is recorded consistently and easy to retrieve.',
    'Information needed for work is available when required.',
    'The existing data structure is suitable to support process automation.'
  ],
  e2: [
    'Current systems support accounting or operational tasks effectively.',
    'Information can move between functions without excessive manual work.',
    'The organization\'s digital infrastructure is adequate to support process improvement.'
  ],
  e3: [
    'Staff have sufficient basic skills to work in a digital environment.',
    'Staff show readiness to accept workflow changes.',
    'The organization provides sufficient training when changes are introduced.'
  ],
  e4: [
    'The organization understands accuracy and data security risks when AI is used.',
    'AI use will be supported by appropriate human review.',
    'The organization is ready to develop guidelines for responsible AI use.'
  ]
};

export const DOMAIN_NAMES = {
  domain1: 'Decision Dependency',
  domain2: 'Process Consistency',
  domain3: 'Repetitive Work',
  domain4: 'Error Control',
  e1: 'Data Readiness',
  e2: 'System Support',
  e3: 'Staff Capability',
  e4: 'AI Governance'
};
